import PropTypes from "prop-types"
import styled from "@emotion/styled"
import { sizer } from "@ninjaone/utils"
import Text from "./Text"

const StyledAvatar = styled.div`
  background-color: ${({ theme }) => theme.color.text};
  color: ${({ theme }) => theme.color.background};

  display: flex;
  justify-content: center;
  align-items: center;

  width: ${sizer(7)};
  height: ${sizer(7)};

  border-radius: 50%;
`

export default function Avatar({ avatar }) {
  return (
    <StyledAvatar>
      <Text size="xs" bold>
        {avatar}
      </Text>
    </StyledAvatar>
  )
}

Avatar.propTypes = {
  avatar: PropTypes.string,
}
